export default function StepBar({ total, current }) {
  return (
    <div style={{ display:"flex", gap:"6px", marginBottom:"24px" }}>
      {Array.from({length:total}).map((_,i)=>(
        <div key={i} style={{ flex:1, height:"4px", borderRadius:"4px",
          background:i<current?"#C9922A":i===current?"#1CBCD3":"#E2E8F0" }} />
      ))}
    </div>
  );
}
